import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build(
	"/admin/search/requests",
	lazy(() => import("./AdminSearchesPage"))
);
